import { useMemo } from 'react';
import { useCardLocationContext } from './CardLocationContext';
import isReadOnlyObjectTypeId from '../utils/isReadOnlyObjectTypeId';
import { normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { useCardData } from './CardDataContext';
export const useCardHookContext = () => {
  var _cardLocationContext$, _cardLocationContext$2;
  const cardLocationContext = useCardLocationContext();
  const {
    cardData
  } = useCardData();
  const {
    subjectObjectCoordinates
  } = cardData;

  // Only use subject coordinates if both values are present
  const useSubjectCoordinates = !!(subjectObjectCoordinates !== null && subjectObjectCoordinates !== void 0 && subjectObjectCoordinates.objectTypeId && subjectObjectCoordinates !== null && subjectObjectCoordinates !== void 0 && subjectObjectCoordinates.objectId);
  const objectTypeId = useSubjectCoordinates && subjectObjectCoordinates ? subjectObjectCoordinates.objectTypeId : (_cardLocationContext$ = cardLocationContext.additionalLocationData) === null || _cardLocationContext$ === void 0 ? void 0 : _cardLocationContext$.objectTypeId;
  const objectId = useSubjectCoordinates && subjectObjectCoordinates ? subjectObjectCoordinates.objectId : (_cardLocationContext$2 = cardLocationContext.additionalLocationData) === null || _cardLocationContext$2 === void 0 ? void 0 : _cardLocationContext$2.objectId;
  const searchFilters = cardLocationContext.additionalLocationData && cardLocationContext.additionalLocationData.searchFilters;
  const searchQuery = cardLocationContext.additionalLocationData && cardLocationContext.additionalLocationData.searchQuery;
  const viewId = cardLocationContext.additionalLocationData && cardLocationContext.additionalLocationData.viewId;
  const {
    editableAreasAtom,
    propertySource
  } = cardLocationContext;
  const cardHookContext = useMemo(() => {
    const readOnly = objectTypeId ? isReadOnlyObjectTypeId(normalizeTypeId(objectTypeId)) : false;
    return {
      editableAreasAtom,
      objectId,
      objectTypeId,
      propertySource,
      readOnly,
      searchFilters,
      searchQuery,
      viewId
    };
  }, [objectId, objectTypeId, editableAreasAtom, propertySource, searchFilters, searchQuery, viewId]);
  return cardHookContext;
};